import { Avatar } from 'element-ui'

const YAvatar = Avatar
YAvatar.$depends = [Avatar]
YAvatar.$name = 'y-avatar'
YAvatar._name = 'Avatar 头像'

export default YAvatar
